import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, endpoint } from "@/api";
import BusinessForm from "./BusinessForm";
import { flare } from "@flareapp/js";

const EditBusiness = () => {
  const params = useParams();
  const businessId = params.businessId;

  const [business, setBusiness] = useState();
  const [loading, setLoading] = useState(false);

  const getBusiness = async () => {
    setLoading(true);
    try {
      const data = await api.get(endpoint.business + businessId);
      setBusiness(data?.data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business update", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBusiness();
  }, []);

  return <Spin spinning={loading}> {business && <BusinessForm mode="edit" data={business} />} </Spin>;
};

export default EditBusiness;
